import { Paragraph } from '@app/shared/ui/atoms/Common';
import { FrontendEnergyStone } from '@app/shared/types/pages/stones';
import { StoneAbility } from '@app/shared/ui/molecules/StoneAbilities';
import { cn } from '@app/shared/utils/common';

export interface StoneDetailsProps {
  stone: FrontendEnergyStone;
  onAbilityClick: (stoneId: number, matrixIndex: number, isPurchased: boolean) => void;
}

export const StoneDetails = ({ stone, onAbilityClick }: StoneDetailsProps) => (
  <div>
    <Paragraph>{stone.name}</Paragraph>
    <ul
      className={cn(!stone.isPurchased && 'brightness-75', 'mt-4 divide-y rounded-2xl px-4 ')}
      style={{ backgroundColor: stone.bg ?? 'gray' }}
    >
      {stone.abilities.map((ability) => (
        <li key={ability.name}>
          <StoneAbility
            icon={ability.icon}
            label={ability.name}
            isLocked={!stone.isPurchased}
            onAbilityClick={() => onAbilityClick(stone.id, ability.matrixIndex, stone.isPurchased)}
          />
        </li>
      ))}
    </ul>
  </div>
);
